module.exports = __webpack_public_path__ + "static/media/ilbc.b9131475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc.jpg
// module id = 187
// module chunks = 0